export const pause = (delay = 200): Promise<void> => new Promise((r) => setTimeout(r, delay));
